import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';
import { PrimaryButton } from '@prisjakt/ui/button/variants';

export const StoreLink = styled.div`
  display: flex;
  align-items: center;

  /* Small mobile resolutions, e.g. Galaxy Fold */
  @media screen and (max-width: 280px) {
    display: none;
  }
`;

type ButtonProps = {
  onlyIcon?: boolean;
};

export const Button = styled(PrimaryButton)<ButtonProps>(
  props => css`
    display: flex;
    width: 100%;

    ${props.onlyIcon &&
      css`
        width: auto;
      `}
  `
);

export const LinkDesktop = styled(PrimaryButton)`
  ${media.smallOnly`
    display:none;
  `}
`;

export const LinkMobile = styled.div`
  display: flex;
  align-items: center;

  ${media.mediumUp`
    display: none;
  `}
`;
